import { jsx as _jsx } from "react/jsx-runtime";
import classes from './ProductLogo.module.scss';
import classNames from 'classnames';
import { LogoIcon } from '@icons';
const ProductLogo = ({ className }) => {
    const containerClasses = classNames(classes.container, className);
    return (_jsx("div", { className: containerClasses, children: _jsx(LogoIcon, { containerClasses: classes.logo }) }));
};
export default ProductLogo;
